import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Dialog, DialogHeader, DialogBody} from '@stubhub/bamboo';

import stores from './config/stores';
import StoreCardList from './store-card-list';

import '../styles/index.scss';

const StoreSelectorModal = ({visible, currentStore, onStoreClick: handleStoreClick, onClose: handleClose}) => {
  return visible ? (
    <Dialog
      className="store-selector-modal__container"
      isOpen={visible}
      closeOnOverlayClick
      closeOnEsc={false}
      onDismiss={handleClose}
      size="xl"
      isModal
    >
      <DialogHeader className="store-selector-modal__header" closeButton>
        <div className="store-selector-modal__header__title" data-testid="store-selector-modal-title">
          <FormattedMessage id="StoreSelectorModal.title" defaultMessage="Choose your preferred store" />
        </div>
        <div className="store-selector-modal__header__subtitle">
          <p data-testid="store-selector-modal-subtitle">
            <FormattedMessage
              id="StoreSelectorModal.subtitle"
              defaultMessage="Your StubHub account, including your current sales and purchases, is shared across all the stores."
            />
          </p>
        </div>
      </DialogHeader>
      <DialogBody className="store-selector-modal__body">
        <StoreCardList stores={stores} activeStore={currentStore} onStoreClick={handleStoreClick} />
      </DialogBody>
    </Dialog>
  ) : null;
};

StoreSelectorModal.propTypes = {
  /**  The currently selected store code */
  currentStore: PropTypes.string,

  /**  Boolean indicating modal visibility */
  visible: PropTypes.bool,

  /**  Function triggered on store selection */
  onStoreClick: PropTypes.func,

  /**  Function triggered on modal close */
  onClose: PropTypes.func,
};

export default StoreSelectorModal;
